import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCalendar, MatCalendarCellClassFunction, MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { validate } from 'schema-utils';


@Component({
  selector: 'app-multi-factor',
  templateUrl: './multi-factor.component.html',
  styleUrls: ['./multi-factor.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class MultiFactorComponent implements OnInit {
  schedule: any;
  constructor(
    public modalCtrl: ModalController,
    private navParams: NavParams,
    public helperService: HelperService,
    public storage: Storage,
    public formBuilder: FormBuilder,
    // private backendService: BackendService,
    private router: Router,) {
    this.schedule = this.navParams.get('Data');
    // this.yesterday.setDate(this.yesterday.getDate());
  }
  mfaForm: FormGroup = this.formBuilder.group({
    otp: ['', [Validators.required]],
  })
  ngOnInit() {
    // var style = document.createElement( 'style' )
    // style.innerHTML = '.modal-wrapper { height: 385px; }'
    // host.shadowRoot.appendChild( style )
    document.querySelector('.modal-default').shadowRoot.querySelector('.modal-wrapper').setAttribute('style', 'height:385px');
  }
  submitMfa() {
    if (this.mfaForm.invalid) {
      return;
    }
    this.modalCtrl.dismiss(this.mfaForm.value);
  }
  checkLength2(e, input) {
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft'];
    if (functionalKeys.indexOf(e.key) !== -1) {
        return;
    }
    const keyValue = +e.key;
    if (isNaN(keyValue)) {
        e.preventDefault();
        return;
    }
    const hasSelection = input.selectionStart !== input.selectionEnd && input.selectionStart !== null;
    let newValue;
    if (hasSelection) {
        newValue = this.replaceSelection(input, e.key)
    } else {
        newValue = input.value + keyValue.toString();
    }
    if (newValue.length > 6) {
        e.preventDefault();
    }
}
private replaceSelection(input, key) {
    const inputValue = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd || input.selectionStart;
    return inputValue.substring(0, start) + key + inputValue.substring(end + 1);
}
}